export default "__VITE_ASSET__Bc8gk9jl__"